import FlightAddToBasket from './flight-add-to-basket-component';

import './flight-add-to-basket.scss';

const MODULE_NAME = 'app.flight.add-to-basket';
const module = angular.module(MODULE_NAME, [])
    .directive(FlightAddToBasket.DIRECTIVE_NAME, FlightAddToBasket);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-add-to-basket/flight-add-to-basket-module.js